import { render, staticRenderFns } from "./footerSouthernEn.vue?vue&type=template&id=549eac50&scoped=true"
import script from "./footerSouthernEn.vue?vue&type=script&lang=js"
export * from "./footerSouthernEn.vue?vue&type=script&lang=js"
import style0 from "./footerSouthernEn.vue?vue&type=style&index=0&id=549eac50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549eac50",
  null
  
)

export default component.exports